import React from 'react';
import _ from 'lodash';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';
import SearchBar from '../../../../searchbar/SearchBar';
import FieldSet from '../../../../fieldset/FieldSet';
import Grid from '../../../../grid/Grid';
import KsDmvService from '../../../../../service/KsDmvService';
import KsDmvModal from './KsDmvModal';
import '../UtilityView.css';

class KsDmv extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      renewals: [],
      rows: [],
      headers: [],
    };
    this.comboFields = [
      {
        value: 'customerId',
        display: 'Customer ID',
      },
      {
        value: 'emailAddress',
        display: 'Email Address',
      },
      {
        value: 'plateNumber',
        display: 'Plate Number',
      },
    ];
  }

  state = undefined;

  onRowSelect(row) {
    this.setState({
      selectedRenewal: row,
    });
  }

  getRenewalActivity(event) {
    const { search, combo, } = event;
    this.reset();
    const vm = this;
    const rows = [];
    let headers = [];

    const criteria = {};
    criteria[combo.value] = search.value;

    const allowedKeys = [
      'id',
      'regExpDate',
      'createdOn',
      'transactionId',
      'emailAddress',
      'plateNumber',
      'year',
      'make',
      'parkPermit',
      'refunded',
      'customerId',
    ];

    KsDmvService.getKsDmvRenewalsBySearchCriteria(criteria)
      .then((response) => {
        const { renewals, } = response.data;
        this.setState({ renewals, });
        if (renewals.length > 0) {
          headers = allowedKeys.map(header => ({
            value: header,
            display: _.startCase(header),
          }));

          renewals.forEach((renewal) => {
            const filtered = _.pick(renewal, allowedKeys);
            filtered.parkPermit = filtered.parkPermit ? 'true' : 'false';
            filtered.refunded = filtered.refunded ? 'true' : 'false';

            const row = Object.values(filtered);

            rows.push({ value: row, });
          });
          vm.setState({
            headers,
            rows,
          });
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  formatSelectedRowDisplay(renewal) {
    if (!renewal) {
      return null;
    }
    return (
      <div>
        <p>{`Selected ID: ${renewal.id}`}</p>
        <hr />
        <KsDmvModal renewal={renewal} />
      </div>
    );
  }

  reset() {
    this.setState({
      renewals: [],
      selectedRenewal: null,
      headers: [],
      rows: [],
    });
  }

  render() {
    const {
      renewals,
      headers,
      rows,
      selectedRenewal,
    } = this.state;
    const style = {
      maxHeight: '400px',
      overflowY: 'auto',
    };
    return (
      <div className="container">
        <SearchBar comboFields={this.comboFields} onClick={data => this.getRenewalActivity(data)} />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Renewals" style={style}>
            <Grid
              headers={headers}
              rows={rows}
              onRowSelect={row => this.onRowSelect(renewals.find(x => x.id === row.id))}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
          {this.formatSelectedRowDisplay(selectedRenewal)}
        </div>
      </div>
    );
  }
}

export default KsDmv;
